var _path, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_angular_2476_5186_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 0.0154839 -0.0154839 0 15.4839 15.4839)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -1020,
    y: -1020,
    width: 2040,
    height: 2040
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(2, 76, 97, 1) 0deg,rgba(6, 121, 155, 1) 63.243deg,rgba(255, 255, 255, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.9677 15.4839C30.9677 24.0354 24.0354 30.9677 15.4839 30.9677C6.93237 30.9677 0 24.0354 0 15.4839C0 6.93237 6.93237 0 15.4839 0C24.0354 0 30.9677 6.93237 30.9677 15.4839ZM4.63009 15.4839C4.63009 21.4783 9.48949 26.3377 15.4839 26.3377C21.4783 26.3377 26.3377 21.4783 26.3377 15.4839C26.3377 9.48949 21.4783 4.63009 15.4839 4.63009C9.48949 4.63009 4.63009 9.48949 4.63009 15.4839Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.0078431377187371254,\"g\":0.29803922772407532,\"b\":0.38039216399192810,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.023529412224888802,\"g\":0.47450980544090271,\"b\":0.60784316062927246,\"a\":1.0},\"position\":0.17567500472068787},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":0.0078431377187371254,\"g\":0.29803922772407532,\"b\":0.38039216399192810,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.023529412224888802,\"g\":0.47450980544090271,\"b\":0.60784316062927246,\"a\":1.0},\"position\":0.17567500472068787},{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":0.0},\"position\":1.0}],\"transform\":{\"m00\":1.8962274597880214e-15,\"m01\":-30.967744827270508,\"m02\":30.967744827270508,\"m10\":30.967744827270508,\"m11\":1.8962274597880214e-15,\"m12\":-1.8962274597880214e-15},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.6385,
    cy: 28.6429,
    r: 2.32258,
    fill: "#024C61"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_angular_2476_5186_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9677 15.4839C30.9677 24.0354 24.0354 30.9677 15.4839 30.9677C6.93237 30.9677 0 24.0354 0 15.4839C0 6.93237 6.93237 0 15.4839 0C24.0354 0 30.9677 6.93237 30.9677 15.4839ZM4.63009 15.4839C4.63009 21.4783 9.48949 26.3377 15.4839 26.3377C21.4783 26.3377 26.3377 21.4783 26.3377 15.4839C26.3377 9.48949 21.4783 4.63009 15.4839 4.63009C9.48949 4.63009 4.63009 9.48949 4.63009 15.4839Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/Icon_Loading.0c53698b0734406b3b71b594aab4a9cf.svg";
export { ForwardRef as ReactComponent };